<template>
  <grid-layout
    v-model:layout="layout"
    :is-draggable="config.isDraggable"
    :is-resizable="config.isResizable"
    :is-mirrored="false"
    :vertical-compact="false"
    use-css-transforms
    :use-percentages="true"
  >
    <grid-item
      v-for="item in layout"
      :x="item.x"
      :y="item.y"
      :w="item.w"
      :h="item.h"
      :i="item.i"
      :key="item.i"
      :dragAllowFrom="'span'"
      :class="{ item: true, border: hasBorder }"
      :style="{ padding: config.itemPadding || '0' }"
    >
      <div class="item-content">
        <template v-if="item.config.component">
          <component
            :is="item.config.component"
            :itemKey="item.config.key"
            v-bind="item.config.props || {}"
          />
        </template>
        <template v-else>
          <span class="text">Layout: {{ item.i }}</span>
        </template>
      </div>
    </grid-item>
  </grid-layout>
</template>
<script setup lang="ts">
import { GridConfig } from 'liyu-pc-base/typing';
import { computed, onMounted } from 'vue';
import { GridItem, GridLayout } from '../grid-layout';

const props = withDefaults(
  defineProps<{
    config: GridConfig;
  }>(),
  {},
);

const layout = computed(() => {
  const keyMap = {};
  return props.config.items.map((item, index) => {
    let i = item.key;
    if (!i) {
      i = `index_${index}`;
    }
    if (keyMap[i]) {
      throw new Error('key: ${i}重复');
    }

    return {
      ...item.layout,
      i: i,
      config: item,
    };
  });
});
const hasBorder = computed(() => {
  return !!props.config.isBorder;
});
onMounted(() => {});
</script>

<style scoped lang="less">
.item {
  position: relative;
}
.border {
  border: 1px solid #ccc;
}
.item-content {
  width: 100%;
  height: 100%;
  background: #fff;
  border-radius: 2px;
  overflow: hidden;
}
</style>
